



























































































































import { Vue, Component } from 'vue-property-decorator'

@Component
export default class BlogName extends Vue {
  get snippet1 () {
    return `row_sum_odd_numbers(1) # 1
row_sum_odd_numbers(3) # 7 + 9 + 11 = return 27`
  }

  get snippet2 () {
    return `def row_sum_odd_numbers(n):
    sum = 0
    start = (n * n) - (n - 1)
    end = start + n * 2
    for i in range(start, end, 2):
        sum += i
    return sum
`
  }

  get snippet3 () {
    return `for i in range(start, end, 2):
      sum += i`
  }
}
